<p-menu #menu [model]="items" [popup]="true" />

<button
  fxLayout="row"
  type="button"
  egButton
  egType="round"
  egButtonSize="small-round"
  egStyle="secondary"
  (click)="menu.toggle($event)"
  [loading]="loading"
  [disabled]="disabled"
>
  <div fxLayoutAlign="center center">
    <img src="/assets/icons/three-dots-vertical.svg" class="svg-to-primary" alt="options" />
  </div>
</button>
